/**
 * ZOY-633 / ZOY-635 — one place that names a permission to a clinic user.
 * Order of truth: a translated label in the reader's language when the
 * catalogue carries one (`perm.<key>` / `perm.<key>.desc`), else the name the
 * Auth catalogue publishes, else — for a key the catalogue no longer lists —
 * the words "retired permission". The internal dotted key is never the
 * user-facing label.
 */

import type { IntlShape } from 'react-intl';
import type { PermissionRow } from '@/core/auth/adminApi';

const has = (intl: IntlShape, id: string): boolean => id in intl.messages;

export function permissionLabel(
  intl: IntlShape,
  key: string,
  catalog: readonly PermissionRow[] | undefined,
): string {
  const id = `perm.${key}`;
  if (has(intl, id)) return intl.formatMessage({ id });
  if (catalog === undefined) return intl.formatMessage({ id: 'perm.loading' });
  const row = catalog.find((r) => r.key === key);
  if (row && row.name.trim() !== '') return row.name;
  return intl.formatMessage({ id: 'perm.retired' });
}

export function permissionDescription(
  intl: IntlShape,
  key: string,
  catalog: readonly PermissionRow[] | undefined,
): string | null {
  const id = `perm.${key}.desc`;
  if (has(intl, id)) return intl.formatMessage({ id });
  const row = catalog?.find((r) => r.key === key);
  return row?.description && row.description.trim() !== '' ? row.description : null;
}
